/**
 * TWWTS — Scroll Reveal + Curtain Footer (v3)
 * - Reveal one-way: una volta visibile resta visibile
 * - Disattivato con prefers-reduced-motion (la classe html.twwts-reveal non viene aggiunta)
 * - Re-init nel theme editor
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var revealOn = root.classList.contains('twwts-reveal') && 'IntersectionObserver' in window;
  var observer = null;

  if (revealOn) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -8% 0px' });
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!observer) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initCurtain() {
    var footer = document.querySelector('.section-twwts-footer');
    if (!footer) return;

    function update() {
      if (window.innerWidth <= 900) {
        footer.style.position = 'relative';
        footer.style.zIndex = '';
        document.body.style.paddingBottom = '0px';
      } else {
        footer.style.position = 'fixed';
        footer.style.zIndex = '0';
        document.body.style.paddingBottom = footer.offsetHeight + 'px';
      }
    }

    update();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(update, 120);
    }, { passive: true });
    window.addEventListener('load', update);
  }

  function init() {
    initReveal();
    initCurtain();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();
